/**
 * File: Footer.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.1
 * Created: 2025-07-26
 * Last Updated: 2026-02-17
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { footer } from "../../schemas/schemas";
import { Link } from "react-router-dom";
import FooterNavigation from "../navigation/FooterNavigation";
import Logo from "../ui/Logo";

// Icons
import { FaLinkedin } from "react-icons/fa";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function Footer() {
    return (
        <>
            <div className="footer">
                <div className="footer__company-information">
                    <Logo isLink={true} />
                    <div className="footer__description">
                        {footer.description}
                    </div>
                    <div className="footer__socials-list">
                        <Link
                            className="footer__social-icon"
                            to={footer.links.linkedInLink}
                        >
                            <FaLinkedin />
                        </Link>
                    </div>
                </div>
                <FooterNavigation props={footer.navigation} />
            </div>
            <hr></hr>
            <div className="footer__legal">
                <div className="footer__copyright-container">
                    <p className="footer__copyright">
                        {footer.legal.copyright}
                    </p>
                    <p className="footer__reserved">{footer.legal.reserved}</p>
                </div>
                <div className="footer__policy-container">
                    <Link
                        className="footer__policy"
                        to={footer.legal.policies[0].link}
                    >
                        {footer.legal.policies[0].label}
                    </Link>
                    <Link
                        className="footer__policy"
                        to={footer.legal.policies[1].link}
                    >
                        {footer.legal.policies[1].label}
                    </Link>
                </div>
            </div>
        </>
    );
}

export default Footer;
